import { diaInterfaceTech } from "../types/index.const";

const diaInterfaceTechOptions = diaInterfaceTech.map((el) => ({
  value: el,
  label: el,
}));
export default diaInterfaceTechOptions;
